import { startPasswordReset } from "../../../../services/api";
import useOriginApp from "../../../../services/useOriginApp";
export default function useFormSubmit(setEmailSent,setEmail){
    const originApp = useOriginApp();
    return function(data){
        setEmailSent('sent');
        console.log('retrieve for ',originApp.path,data.username);
        startPasswordReset(
            originApp.path,
            data.username,
            r=>{
                console.log('RESPONSE ok',r);
                setEmail(data.username)
            },
            r=>{
                console.log('RESPONSE ERROR',r);
                setEmailSent('fail');
            }
        );
    }
}
